import {
  clone,
  concat
} from 'lodash'

import FlashMessages from '../constants/flashMessages'

export const ADD_ERROR_FLASH = 'flashes/ADD_ERROR_FLASH'
export const ADD_SUCCESS_FLASH = 'flashes/ADD_SUCCESS_FLASH'
export const REMOVE_FLASH = 'flashes/REMOVE_FLASH'

const initialState = {
  errors:  [],
  success: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_SUCCESS_FLASH:
      return {
        ...state,
        success: concat(state.success, action.flashMessage)
      }

    case ADD_ERROR_FLASH:
      return {
        ...state,
        errors: concat(state.errors, action.flashMessage).sort()
      }

    case REMOVE_FLASH:
      const flashArray = clone(state[action.flashType])
      const index = flashArray.indexOf(action.flashMessage)
      if (index >= 0) {
        flashArray.splice(index, 1)
      }

      return {
        ...state,
        [action.flashType]: flashArray.sort()
      }

    default:
      return state
  }
}

export const removeFlash = (flashType, flashMessage, dispatch) => setTimeout(() => dispatch({
  type: REMOVE_FLASH,
  flashType,
  flashMessage
}), 3000)

export const addFlash = flashCode => (dispatch) => {
  if (flashCode) {
    let successFlashMessage = FlashMessages.success[flashCode]
    let errorFlashMessage   = FlashMessages.errors[flashCode]

    if (successFlashMessage) {
      dispatch({
        type:         ADD_SUCCESS_FLASH,
        flashMessage: successFlashMessage
      })

      removeFlash('success', successFlashMessage, dispatch)
    }

    if (errorFlashMessage) {
      dispatch({
        type:         ADD_ERROR_FLASH,
        flashMessage: errorFlashMessage
      })

      removeFlash('errors', errorFlashMessage, dispatch)
    }
  }
}
